// import React from 'react'
import React, { Suspense, lazy } from "react";

import { placeholder } from "@/lib/imageIcon";

// Lazy-loaded component for the actual image
const LazyImage = lazy(() => import("./LazyImage"));

const ImageWithErrorHandling = ({ alt, src, width, className }) => {
  const widthWidth = width || 24;

  return (
    <div
      key={alt}
      className={className}
      style={{
        width: widthWidth,
      }}
    >
      <Suspense
        fallback={
          <img
            src={placeholder}
            alt="Loading..."
            width={widthWidth}
            className={className}
          />
        }
      >
        <LazyImage alt={alt} src={src} widthWidth={widthWidth} />
      </Suspense>
    </div>
  );
};

export default ImageWithErrorHandling;
